import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

export default function ReferralRedirect() {
    const { refKey } = useParams<{ refKey: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (refKey) {
            console.log('ref redirect');
            localStorage.setItem('ref_key', refKey);
            navigate('/', { replace: true });
        }
    }, [refKey, navigate]);

    return null;
}
